module.exports = __webpack_public_path__ + "static/media/civic.25251fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/civic.jpg
// module id = 1870
// module chunks = 146